module.exports = __webpack_public_path__ + "static/media/ey-logo.0aef3099.svg";